import { render } from "./NotificationSettings.vue?vue&type=template&id=317514b4&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"

import "./NotificationSettings.vue?vue&type=style&index=0&id=317514b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317514b4"]])

export default __exports__